import {Injectable} from '@angular/core';
import {Subject} from 'rxjs';
import dashboardIcon from '@iconify/icons-mdi/view-dashboard-outline';
import listIcon from '@iconify/icons-mdi/view-list-outline';
import reportIcon from '@iconify/icons-mdi/chart-areaspline';

export interface MenuItem {
  id: number;
  name: string;
  icon: string;
  selectable: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class TransportInterventionsNavigationService {

  current: MenuItem;
  backgroundMenu: MenuItem;

  menu = [{
    id: 1,
    name: 'Tableau de bord',
    icon: `<svg  width="18px" height="18px" viewBox="0 0 24 24">${dashboardIcon.body}</svg>`,
    selectable: true,
  }, {
    id: 2,
    name: 'Liste',
    icon: `<svg  width="18px" height="18px" viewBox="0 0 24 24">${listIcon.body}</svg>`,
    selectable: true,
  }, /*{
    id: 3,
    name: 'Rapport',
    icon: `<svg  width="18px" height="18px" viewBox="0 0 24 24">${reportIcon.body}</svg>`,
    selectable: true,
  }, {
    id: 4,
    name: 'Paramètres',
    icon: 'preferences',
    selectable: false,
  }*/];

  private _navigationSubject = new Subject<{ current: MenuItem, background: MenuItem }>();
  navigate$ = this._navigationSubject.asObservable();

  constructor() {
    this.current = this.menu[0];
    this.backgroundMenu = this.menu[0];
  }

  navigateTo(menu: MenuItem) {
    this.backgroundMenu = !menu.selectable ? this.current : menu;
    this.current = menu;
    this._navigationSubject.next({current: menu, background: this.backgroundMenu});
  }

  navigateById(id: number) {
    const menu = this.menu.find((m) => m.id === id);
    if (menu) {
      this.navigateTo(menu);
    }
  }

}
